<template>
<div class="container section-story">
  <p v-for="(paragraph, idx) in section.text"
     :key="`${section.sname}-${idx}`"
     class="is-size-4">
     {{ paragraph }}
  </p>
</div>
</template>

<style lang="scss">
.section-story:first-child .container {
  padding-top: 2em;
}

.img-container img{
  margin:2em 0;
}

</style>
<script>
export default {
  name: 'StorySection',
  props: {
    section: Object,
  },
};
</script>
